import React from 'react'
import Pt from 'prop-types'
import moment from 'moment'

export default function Footer(_, { version }) {
  return (
    <footer className="footer">
      <div className="container">
        <p className="pull-right text-muted">
          <a href="https://www.infinite.net.au/privacy-policy/">
            Privacy
            <span className="hidden-xs"> Policy</span>
          </a>{' '}
          &mdash;{' '}
          <a href="https://www.infinite.net.au/policies-agreements/">
            Terms
            <span className="hidden-xs"> &amp; Conditions</span>
          </a>
        </p>

        <p className="text-muted" title="Infinite Networks Pty Ltd">
          <span aria-label="Copyright" role="img">
            &copy;
          </span>{' '}
          Infinite
          <span className="hidden-xs">
            {' '}
            Networks Pty Ltd {moment().format('YYYY')}
          </span>{' '}
          &mdash; <span id="version">{version}</span>
        </p>
      </div>
    </footer>
  )
}

Footer.contextTypes = {
  version: Pt.string,
}



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.jsx